import React, { FC, useContext } from 'react';
import { PAGE } from '../../../../../../constants';
import { Breadcrumb } from '@sravni/react-design-system';
import { BreadcrumbProps } from '@sravni/react-design-system/lib/Breadcrumb';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import styles from './styles.module.scss';
import { useFormStore } from '../../../../../../store/selectors/formStore';
import { StepContext } from '../../../../creator/step.context';

const steps = [
    { desktop: 'Параметры кредита', mobile: 'Параметры' },
    { desktop: 'Личные данные', mobile: 'Паспорт' },
    { desktop: 'Место работы', mobile: 'Работа' },
];

const creditCardsSteps = [
    { desktop: 'Параметры карты', mobile: 'Параметры' },
    { desktop: 'Паспортные данные', mobile: 'Паспорт' },
    { desktop: 'Место работы', mobile: 'Работа' },
];

interface ItemProps {
    stepData: { desktop: string; mobile: string };
    i: number;
    isMobile?: boolean;
    disabled: boolean;
    active: boolean;
}

const Item: React.FC<ItemProps> = (props) => {
    const { stepData, isMobile, i, disabled, active } = props;
    const { currentStep, setStep } = useContext(StepContext);

    const onClick = () => {
        if (i < currentStep) {
            setStep(i);
        }
    };

    return (
        <Text size={12} onClick={!disabled && !active ? onClick : undefined} className={styles['item-text']}>
            {isMobile ? (currentStep === i ? stepData.desktop : `Шаг ${i + 1}`) : stepData.desktop}
        </Text>
    );
};

type NavigationProps = BreadcrumbProps;

export const FormNavigationB: FC<NavigationProps> = (props) => {
    const { className } = props;
    const { currentStep } = useContext(StepContext);
    const { page } = useFormStore();
    const isMobile = useIsMobile();

    if (page == PAGE.AVITO) {
        steps.shift();
        steps.unshift({ desktop: 'Контакты', mobile: 'Контакты' });
    }

    return (
        <Breadcrumb className={className}>
            {(page == PAGE.CARDS_RESTORE ? creditCardsSteps : steps).map((step, i) => {
                const isDisabled = currentStep < i;
                const isActive = currentStep === i;

                return (
                    <Breadcrumb.Item
                        key={i}
                        className={cn(styles['breadcrumb-item'], {
                            [styles['breadcrumb-item_disabled']]: isDisabled,
                            [styles['breadcrumb-item_active']]: isActive,
                        })}>
                        <Item stepData={step} i={i} isMobile={isMobile} disabled={isDisabled} active={isActive} />
                    </Breadcrumb.Item>
                );
            })}
        </Breadcrumb>
    );
};
